import React from "react";
import styled from "styled-components";
import NftMarketHomepage from "../NftMarketPage/NftMarketHomepage";

import ActiveUpcomingNft from "./ActiveUpcomingNft";

const Root = styled.div`
  /* padding-bottom: ${(p) => p.theme.spacing.sm}; */
  margin-bottom: 60px;
`;
const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  @media (max-width: ${(p) => p.theme.screen.lg}) {
    width: 90%;
  }
  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: calc(100% - 40px);
  }
`;

const AuctionNft = (props) => {
  return (
    <Root>
      <Container>
        <NftMarketHomepage allContractDetails={allContractDetails} />
        {/* <BannerNftMarket
          countdownTimestampMs={1735686000000}/> */}
        <ActiveUpcomingNft {...props} />
      </Container>
    </Root>
  );
};

export default AuctionNft;
